module.exports = "/img/sandflix_logo.png?98a68553b50008bce6eb54b7f703d149";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/sandflix_logo.png
// module id = IXR8
// module chunks = 76